
import { defineComponent, onMounted, ref, reactive, computed } from 'vue';
import * as U from "@/util"
import * as Name from "@/models/name"
import * as CellPhone from "@/models/cellphone_number"
import * as _ from "lodash"

const GoogleMapsApiLoader = require('google-maps-api-loader')

const GoogleMapsAPIKey = "AIzaSyC1D5t5nJlu-_QdJrT2x2K835pLSZKQPQk"
const mapConfig = {
  zoom: 12,
  center: {"lat":35.6432027,"lng":139.6729435},
}

type LatLng = {
  lat: number
  lng: number
}
function ll(latLngLike: any): LatLng | null {
  if (typeof latLngLike === "object") {
    if (typeof latLngLike.lat === "function" && typeof latLngLike.lng === "function") {
      return { lat: latLngLike.lat(), lng: latLngLike.lng() }
    }
    if (typeof latLngLike.lat === "number" && typeof latLngLike.lng === "number") {
      return { lat: latLngLike, lng: latLngLike.lng }
    }
  }
  return null;
}

type GeocoderAddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
}

type GeocoderResult = {
  address_components: GeocoderAddressComponent[];
  formatted_address: string;
  partial_match: boolean;
  place_id: string;
  types: string[];
}

// function address_components(result: GeocoderResult) {
//   const components = result.address_components.filter((c) => {
//     return !(c.types.includes("postal_code") || c.types.includes("country") || c.types.includes("route"));
//   });
//   return components.reverse();
// }


function format_address_traditionally(result: GeocoderResult) {
  const t = U.u_hankakunize_digit(result.formatted_address);
  const m = t.match(/〒.+$/);
  return m ? m[0] : "(不明)"
  // return address_components(result).map((c) => c.long_name).join(" | ")
}

type PanelPamameter = {
  position: LatLng | null;
  gender: "M" | "F";
};

type PersonData = {
  address: string;
  gender: "M" | "F";
  fullname: string;
  cellphone_number: string;
}

export default defineComponent({
  name: 'Map',
  setup() {
    const panelParameter: PanelPamameter = reactive({
      position: null,
      gender: "M",
    })
    const personData: PersonData = reactive({
      address: "",
      gender: "M",
      fullname: "",
      cellphone_number: "",
    })

    const personDataText = computed(() => {
      return _.compact([
        personData.address,
        personData.cellphone_number,
        personData.fullname ? `${personData.fullname} ${personData.gender === "M" ? "男" : "女"}性` : "",
      ]).join(`\n`);
    })

    const mapel = ref<HTMLElement | null>(null)
    const mapItem: {
      google: any;
      map: any;
      geocoder: any;
      primalMarker: any;
    } = reactive({
      google: null,
      map: null,
      geocoder: null,
      primalMarker: null,
    })

    const calldownMarker = async (position: LatLng) => {
      if (mapItem.primalMarker) {
        mapItem.primalMarker.setPosition(position)
      } else {
        mapItem.primalMarker = new mapItem.google!.maps.Marker({
          position, map: mapItem.map!,
        })
      }

      try {
        panelParameter.position = position
      } catch (e) {
        panelParameter.position = null
        console.error(e)
      }
    }

    const geocodeLocation = (location: LatLng) => {
      return new Promise<GeocoderResult[]>((res,rej) => {
        try {
          mapItem.geocoder.geocode({ location }, (results: any, status: any) => {
            if (status !== "OK") { rej(status); return }
            console.log(results)
            res(results);
          });
        } catch(e) {
          rej(e)
        }
      })
    }

    const initializeGoogle = async () => {
      mapItem.google = await GoogleMapsApiLoader({ apiKey: GoogleMapsAPIKey })
    }

    const initializeMap = () => {
      const mapContainer = mapel.value!
      const { Map } = mapItem.google.maps
      mapItem.geocoder = new mapItem.google.maps.Geocoder()
      console.log(mapItem.google, Map)
      const map = new Map(mapContainer, mapConfig)

      map.addListener("click", (e: any) => {
        const latlng = ll(e.latLng)
        if (!latlng) { return }
        calldownMarker(latlng)
      });

      mapItem.map = map
    }

    onMounted(async () => {
      console.log(mapel.value)
      await initializeGoogle()
      initializeMap()
    })
    const rollers = {
      rollFullname: (gender: "M" | "F") => {
        return `${Name.roll_family_name().name} ${Name.roll_first_name(gender)}`;
      },
      rollAddress: async (position: LatLng) => {
        const result = await geocodeLocation(position);
        return format_address_traditionally(result[0])
      },
      rollCellphoneNumber: () => CellPhone.roll_cell_number(),
    }
    return {
      panelParameter,
      personData,
      mapel,
      personDataText,

      ...rollers,
      updateAddress: async () => {
        if (!panelParameter.position) { return }
        const address = await rollers.rollAddress(panelParameter.position)
        personData.address = address
        personData.fullname = rollers.rollFullname(panelParameter.gender)
        personData.cellphone_number = rollers.rollCellphoneNumber()
      },

      copyPersonData: () => {
        if (navigator.clipboard && personDataText.value) {
            navigator.clipboard.writeText(personDataText.value)
        }
      },
    }
  },
});
